import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SagtoastComponent } from './sagtoast.component';


const routes: Routes = [{
  path:"",
  component:SagtoastComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SagtoastRoutingModule { }
